<template>
  <div class="application">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClickTab">
      <el-tab-pane label="可申请" name="automatic" style="padding-top: 10px">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            prop="event_name"
            label="赛事"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="rank"
            label="等级"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="creationTime"
            label="赛事年份"
            align="center"
            :formatter="formatDate"
          ></el-table-column>
          <el-table-column prop="4" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="application(scope.row)"
                type="text"
                size="middle"
                >申请</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="手动申请" name="manual" style="margin-top: 15px">
        <el-form
          :model="ruleForm"
          :rules="rules"
          status-icon
          ref="ruleForm"
          label-width="170px"
          class="demo-ruleForm"
          enctype="multipart/form-data"
        >
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="18">
              <el-form-item label="请选择赛事：" prop="event_id" required>
                <el-select
                  v-model="ruleForm.event_id"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    placeholder="请选择赛事"
                    v-for="item in optionsMetaShow2"
                    :key="item.id"
                    :label="item.event_name"
                    :value="item.id"
                    :disabled="isdisabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18">
              <el-form-item label="请选择等级：" prop="apply_grade" required>
                <el-select
                  v-model="ruleForm.apply_grade"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    placeholder="请选择等级"
                    v-for="item in optionsMetaShow"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="isdisabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="13">
              <el-form-item label="请上传证明" :error="error" :required="true">
                <el-upload
                  class="avatar-uploader center"
                  action="#"
                  accept=".png, .jpeg, .jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="loadJsonFromFile"
                  :disabled="isdisabled"
                >
                  <img
                    v-if="imageUrl"
                    :src="imageUrl"
                    class="avatar"
                    @mouseover="imgMouseover()"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div
                    class="el-upload-show"
                    :style="active"
                    @mouseleave="imgMouseleave()"
                  >
                    <span class="el-upload-span1">
                      <span
                        class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreview()"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span @click.stop="handleRemove()" v-if="!isdisabled">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18">
              <el-form-item label>
                <p style="font-size: 12px">
                  图片只能是 JPG/PNG 格式且大小不能超过4M
                </p>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="18">
              <el-form-item class="center">
                <el-button
                  type="danger"
                  style="margin-top: 20px; width: 100px; height: 40px"
                  @click="submit('ruleForm')"
                  :loading="loading"
                  >申请</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { GetDicData } from "@/api/admin/common.js";
import { mapGetters } from "vuex";
import {
  GetEventAthleteList,
  GetEventsList,
  GetEventsAthleteApplyList,
  GetManualApplicationList,
} from "@/api/admin/athletes.js";
export default {
  data() {
    return {
      activeName: "automatic",
      optionsMetaShow: [],
      optionsMetaShow2: [],
      optionsMetaShowAll: [],
      tableData: [],
      imageUrl: "",
      totalCount: 0,
      paging: {
        limit: 5,
        page: 1,
      },
      rules: {
        event_id: [
          { required: true, message: "请选择赛事", trigger: "change" },
        ],
        apply_grade: [
          { required: true, message: "请选择等级", trigger: "change" },
        ],
      },
      ruleForm: {
        event_id: "",
        apply_grade: "",
      },
      localFile: {},
      isdisabled: false,
      error: "",
      dialogVisible: false,
      dialogImageUrl: "",
      disabled: false,
      automaticData: {},
      manualData: {},
      listData: {},
      active: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["personalInfo"]),
  },
  created() {
    this.athlete_rank = this.personalInfo.athlete_rank;
    this.comparativeLevel();
  },
  methods: {
    comparativeLevel() {
      //
      this.getList();
      // if (this.athlete_rank > 7 || this.athlete_rank == "") {
      //   this.$message.error("您当前的等级小于7级，不能进行赛事申请");
      // } else {
      //   this.getList();
      // }
    },
    getList() {
      // GetEventsApplyList({}).then(data => {
      //   let list = data.data.result;
      //   if (list) {
      //     this.listData = list.items;
      //     if(this.listData){
      //        this.compareData();
      //     }
      //   }
      // });
      GetEventAthleteList(Object.assign(this.paging)).then((data) => {
        let list = data.data.result;
        if (list) {
          this.tableData = list.items;
          this.totalCount = list.totalCount;
        }
      });
      GetDicData({ classCode: "certificate_grade" }).then((data) => {
        if (data.data.result) {
          this.optionsMetaShowAll = data.data.result;

          for (let i = 0; i < this.optionsMetaShowAll.length; i++) {
            if (
              // this.optionsMetaShowAll[i].value == 3 ||
              this.optionsMetaShowAll[i].value == 4 ||
              this.optionsMetaShowAll[i].value == 5 ||
              this.optionsMetaShowAll[i].value == 6
            ) {
              this.optionsMetaShow.push(this.optionsMetaShowAll[i]);
            }
          }
        }
      });
      GetEventsList({}).then((data) => {
        var list = data.data.result;
        if (list) {
          this.optionsMetaShow2 = data.data.result.items;
        }
      });
    },
    formatDate(row) {
      let moment = require("moment");
      return moment(row.creationTime).format("YYYY");
    },
    handleClickTab(tab, event) {
      window.console.log(tab, event);
    },
    // 自动申请
    application(row) {
      this.automaticData.apply_grade = row.rankId;
      this.automaticData.event_id = row.event_id;
      GetEventsAthleteApplyList(Object.assign(this.automaticData)).then(
        (data) => {
          var list = data.data.result;
          if (list.isSuccess == true) {
            this.$message({
              message: "您的申请已提交，请等待审核",
              type: "success",
            });
            this.$router.push({
              path: "/personal/competitionApplicationRecord",
            });
          } else {
            this.$message.error("申请失败");
          }
        }
      );
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    loadJsonFromFile(file) {
      this.localFile = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(this.localFile);
      reader.onload = () => {
        const isJPG =
          this.localFile.type === "image/jpeg" ||
          this.localFile.type === "image/png";
        const isLt4M = this.localFile.size / 1024 / 1024 < 4;
        if (!isJPG) {
          this.localFile = {};
          this.$message.error("上传图片只能是 JPG/PNG 格式!");
        } else {
          this.imageUrl = reader.result;
        }
        if (!isLt4M) {
          this.$message.error("上传图片大小不能超过 4MB!");
        }
        return isJPG && isLt4M;
      };
    },
    handlePictureCardPreview() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.imageUrl;
    },
    handleRemove() {
      this.imageUrl = "";
      this.localFile = {};
      this.ruleForm.athletes_photo = "";
      this.active = "display:none;opacity: 0;";
    },
    imgMouseover() {
      this.active = "display:block;opacity: 1";
    },
    imgMouseleave() {
      this.active = "display:none;opacity: 0;";
    },
    submit(ruleForm) {
      this.loading = true;

      this.ruleForm.isFormSubmit = true;
      this.ruleForm.athletes_photo = this.localFile;
      if (!this.imageUrl) {
        this.error = "请上传证明图片";
      } else {
        this.error = "";
      }
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.imageUrl) {
            this.error = "";
            this.isdisabled = true;
            this.disabled = true;
            GetManualApplicationList(Object.assign(this.ruleForm)).then(
              (data) => {
                var list = data.data.result;
                if (list.isSuccess == true) {
                  this.loading = false;
                  this.imageUrl = "";
                  this.localFile = {};
                  this.ruleForm = {};
                  this.$message({
                    message: "您的申请已提交，请等待审核",
                    type: "success",
                  });
                  this.$router.push({
                    path: "/personal/competitionApplicationRecord",
                  });
                } else {
                  this.$message.error("申请失败");
                }
              }
            );
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less">
.application {
  .demo-ruleForm {
    width: 80%;
    // 去掉边框
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .el-upload-show {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      display: none;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      line-height: 9;
      .el-upload-span1 {
        span {
          padding: 0px 20px;
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .demo-ruleForm {
      width: 100% !important;
      .el-form-item__label {
        width: 110px !important;
        float: none;
      }
      .el-form-item__content {
        margin-left: 30px !important;
        float: none;
      }
      .center {
        text-align: center;
      }
      .content {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
    }
  }
}
</style>
